import React from 'react';
import Select from 'react-select';
import { useImmer } from 'use-immer';
import { useDispatch, useSelector } from 'react-redux';

import {
  createNewSeed,
  resetCreateNewSeedState,
} from 'store/collections/seeds/actions.js';
import Button from 'components/common/Button';
import HelpIcon from 'assets/help_grey.svg';
import { toast } from 'react-toastify';
import CustomToast from 'components/common/CustomToast';

const seedTypeOptions = [
  { label: 'Other', value: 'other' },
  { label: 'Domain', value: 'domain' },
];

const customStyles = {
  menu: (provided, state) => ({ ...provided, marginTop: '1px' }),
};

export const NewSeedModalContent = (props) => {
  const [state, setState] = useImmer({
    addSeedType: null,
    addSeedName: '',
    showInputError: [],
  });
  const dispatch = useDispatch();
  const systemMetadata = useSelector((state) => state.misc.fetchSystemMetadata);
  const createNewSeedState = useSelector(
    (state) => state.collection.seeds.create
  );

  if (createNewSeedState.success) {
    toast(() => <CustomToast toastType="success" message="New Seed added" />);
    props.closeNewSeedModalWithRefresh();
    dispatch(resetCreateNewSeedState());
  }

  if (createNewSeedState.error) {
    toast(() => (
      <CustomToast toastType="error" message="Something went wrong" />
    ));

    dispatch(resetCreateNewSeedState());
  }

  const renderSeedTypeOptions = () => {
    const seedtypeOptions = systemMetadata?.data?.valid_entity_types?.length
      ? systemMetadata?.data?.valid_entity_types?.map((item, index) => {
          return {
            label: item,
            value: item,
          };
        })
      : [];

    console.log(
      'seedtypeOptions',
      seedtypeOptions,
      systemMetadata?.data?.valid_entity_types
    );
    return (
      <React.Fragment>
        <Select
          className={`${
            state.showInputError.includes('addSeedType')
              ? `border border-reds-r500`
              : ``
          }`}
          // inputValue={defaultValue}
          styles={customStyles}
          options={seedtypeOptions}
          value={state.addSeedType}
          isSearchable={false}
          name="addSeedType"
          onChange={onChangeSelect}
          placeholder="Select Seed Type"
          // defaultValue={defaultValue}
          // defaultInputValue={defaultValue}
        />
      </React.Fragment>
    );
  };

  const onChangeSelect = (value, target) => {
    console.log('on change select', target.name, target);
    setState((draft) => {
      draft[target.name] = value;
    });
  };

  const onChangeText = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setState((draft) => {
      draft[name] = value;
    });
  };

  const validateInput = () => {
    if (state.addSeedType !== null && state.addSeedName.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const addNewSeed = () => {
    if (validateInput()) {
      console.log('state.addSeedType.value', state.addSeedType.value);
      const formData = {
        entities: [
          {
            type: `Intrigue::Entity::${state.addSeedType.value}`,
            name: state.addSeedName,
            seed: true, //hardcoded
          },
        ],
      };
      console.log('formdata', formData);
      dispatch(createNewSeed(props.collectionName, formData));
    } else {
      setState((draft) => {
        let fieldErrorArr = [];
        if (state.addSeedType === null) {
          fieldErrorArr.push('addSeedType');
        }
        if (state.addSeedName === '') {
          fieldErrorArr.push('addSeedName');
        }
        draft.showInputError = fieldErrorArr;
      });

      toast(() => (
        <CustomToast
          toastType="error"
          message="Please fill relevant input fields"
        />
      ));
    }
  };

  return (
    <div className="mt-4">
      <div className="text-gray-800 text-2xl font-bold mb-2 ml-2 flex items-center">
        <span>New Seed</span>{' '}
        <div className="ml-6 relative new-seed-tooltip-parent">
          <img src={HelpIcon} width="30" height="30" />
          <span className="w-64 font-medium bg-secondary-active text-white absolute new-seed-tooltip-child text-sm border border-gray-300 px-2 py-2 rounded-sm">
            Info for new seed
          </span>
        </div>
      </div>
      <div className="mt-10 px-10 text-md">
        <div className="flex  flex-wrap w-full mt-8">
          <div className="w-3/12">Type</div>
          <div className="pl-3 w-9/12">{renderSeedTypeOptions()}</div>
        </div>

        <div className="flex  flex-wrap w-full mt-8 items-center">
          <div className="w-3/12">Seed Name</div>
          <div className="pl-3 w-9/12">
            <input
              name="addSeedName"
              className={`px-2 py-2 rounded-md border border-gray-500 w-full ${
                state.showInputError.includes('addSeedName')
                  ? `border-red-600`
                  : ``
              }`}
              placeholder="Collection Name"
              value={state.addSeedName}
              onChange={onChangeText}
              type="text"
            />
          </div>
        </div>

        <div className="mt-16 text-right">
          <div className="flex items-center justify-between">
            <div>
              <a
                href=""
                className="cursor-pointer text-primary-500 font-bold"
                onClick={(e) => {
                  e.preventDefault();
                  props.openAddSeedFromFile();
                }}
              >
                or, upload a file
              </a>
            </div>
            <div className="flex items-center">
              <Button
                intent="secondary"
                // showSpinner={true}
                type="button"
                extendClass="text-md"
                onClick={props.closeNewSeedModal}
                // loading={createNewSeedState.loading ? true : false}
                //   disable={createNewSeedState.loading ? false : isSubmitting}
              >
                Cancel
              </Button>
              <Button
                intent="primary"
                showSpinner={true}
                type="button"
                extendClass="ml-2 text-md"
                onClick={addNewSeed}
                loading={createNewSeedState.loading ? true : false}
                //   disable={createNewSeedState.loading ? false : isSubmitting}
              >
                Add seed
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// NEW MODAL

export const AddSeedFromFileModalContent = (props) => {
  return (
    <div className="mt-4">
      <div className="text-gray-800 text-2xl font-bold mb-2 ml-2 flex items-center">
        <span>Add seeds from file</span>{' '}
        <div className="ml-6 relative new-seed-tooltip-parent">
          <img src={HelpIcon} width="30" height="30" />
          <span className="w-64 font-medium bg-secondary-active text-white absolute new-seed-tooltip-child text-sm border border-gray-300 px-2 py-2 rounded-sm">
            Info for add seed from file
          </span>
        </div>
      </div>

      <div className="mt-10 px-10 text-md">
        <div className="flex  flex-wrap w-full mt-8 items-center">
          <div className="w-3/12">File Name</div>
          <div className="pl-3 w-9/12">
            <input
              name="addSeedName"
              className="px-2 py-2 rounded-md border border-gray-500 w-full"
              disabled={true}
              placeholder="Collection Name"
              value={props.addSeedName}
              type="text"
            />
          </div>
        </div>

        <div className="mt-16 text-right">
          <Button
            intent="primary"
            // showSpinner={true}
            type="button"
            extendClass="text-md"
            // onClick={() => {
            //   setState((draft) => {
            //     draft.toggleAddSeed = true;
            //   });
            // }}
            // loading={sendUserInviteTeamState.loading ? true : false}
            //   disable={userLoginState.loading ? false : isSubmitting}
          >
            Cancel
          </Button>
          <Button
            intent="primary"
            // showSpinner={true}
            type="button"
            extendClass="ml-2 text-md"
            // onClick={() => {
            //   setState((draft) => {
            //     draft.toggleAddSeed = true;
            //   });
            // }}
            // loading={sendUserInviteTeamState.loading ? true : false}
            //   disable={userLoginState.loading ? false : isSubmitting}
          >
            Add seeds
          </Button>
        </div>
      </div>
    </div>
  );
};
